var _defs, _path, _line, _path2, _path3, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path4, _line9, _line0, _line1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnadressedPreExistingConditionscopy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448.55 448.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#f26725;stroke-linecap:round;stroke-linejoin:round;stroke-width:10.25px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m275.15,109.2v241.41c0,8.66-7.02,15.67-15.67,15.67H82.94c-8.66,0-15.67-7.02-15.67-15.67V97.95c0-8.66,7.02-15.67,15.67-15.67h218.92"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 356.5,
    y1: 291.53,
    x2: 294.17,
    y2: 291.53
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m301.86,82.28c-14.76,0-26.72,11.96-26.72,26.72"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m354.93,115.86h26.35v149.32c0,14.55-11.8,26.35-26.35,26.35h0c-14.55,0-26.35-11.8-26.35-26.35V108.99c0-14.76-11.96-26.72-26.72-26.72"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.56,
    y1: 124.92,
    x2: 194.97,
    y2: 124.92
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 223.41,
    y1: 124.92,
    x2: 236.65,
    y2: 124.92
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.56,
    y1: 172.75,
    x2: 170.75,
    y2: 172.75
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 223.41,
    y1: 172.75,
    x2: 236.65,
    y2: 172.75
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.56,
    y1: 220.58,
    x2: 194.97,
    y2: 220.58
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 223.41,
    y1: 220.58,
    x2: 236.65,
    y2: 220.58
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.56,
    y1: 326.97,
    x2: 170.75,
    y2: 326.97
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m199.7,320.41c3.63,4.75,10.03,7.9,17.32,7.9,11.32,0,20.49-7.61,20.49-16.99,0-8.89-8.25-15.89-18.72-16.93h.01c-9.51-.68-16.98-7.3-16.98-15.37,0-8.52,8.33-15.43,18.61-15.43,6.52,0,12.27,2.79,15.59,7"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 218.6,
    y1: 329.03,
    x2: 218.6,
    y2: 341.05
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 218.6,
    y1: 250.01,
    x2: 218.6,
    y2: 262.54
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.56,
    y1: 277.47,
    x2: 149.43,
    y2: 277.47
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnadressedPreExistingConditionscopy2);
export default __webpack_public_path__ + "static/media/Unadressed Pre-Existing Conditions copy 2.17641050c9f11cc8542429cef02b6d5c.svg";
export { ForwardRef as ReactComponent };